import BossModel from "@/models/BossModel";

export default class UniqueSellingPoint extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'country/unique-selling-point';

    /**
     *
     * @type {string}
     */
    static entity = 'countryUniqueSellingPoints';

    static fields() {
		return {
			id: this.number(null).nullable(),
			sort_order: this.number(null).nullable(),
			text: this.attr(null),
			country_id: this.number(null).nullable(),
		}
	}
}
